import AyamUtuh from "../assets/images/Ayam-Utuh.png";
import AyamPaha from "../assets/images/Ayam-Paha.png";
import AyamSayap from "../assets/images/Ayam-Sayap.png";
import AyamDada from "../assets/images/Ayam-Dada.png";
import AyamCeker from "../assets/images/Ayam-Ceker.png";
import SapiCokor from "../assets/images/Sapi-Cokor.png";
import SapiEkor from "../assets/images/Sapi-Ekor.png";
import SapiGandik from "../assets/images/Sapi-Gandik.png";
import SapiHasDalam from "../assets/images/Sapi-Has-Dalam.png";
import SapiHasLuar from "../assets/images/Sapi-Has-Luar.png";
import SapiIga from "../assets/images/Sapi-Iga.png";
import SapiKelapa from "../assets/images/Sapi-Kelapa.png";
import SapiLamusirDepan from "../assets/images/Sapi-Lamusir-Depan.png";
import SapiSandungLamur from "../assets/images/Sapi-Sandung-Lamur.png";
import SapiPahaDepan from "../assets/images/Sapi-Paha-Depan.png";
import SapiPunuk from "../assets/images/Sapi-Punuk.png";
import SapiSancan from "../assets/images/Sapi-Sancan.png";
import SapiSengkel from "../assets/images/Sapi-Sengkel.png";
import SapiTanjung from "../assets/images/Sapi-Tanjung.png";

export const MenuList = [
  {
    name: "Ayam Utuh",
    image: AyamUtuh,
    desc: "Ayam utuh segar",
    order: "Pesan sekarang!",
  },
  {
    name: "Dada Ayam",
    image: AyamDada,
    desc: "Bagian dada ayam segar",
    order: "Pesan sekarang!",
  },
  {
    name: "Paha Ayam",
    image: AyamPaha,
    desc: "Bagian paha ayam segar",
    order: "Pesan sekarang!",
  },
  {
    name: "Sayap Ayam",
    image: AyamSayap,
    desc: "Bagian sayap ayam segar",
    order: "Pesan sekarang!",
  },
  {
    name: "Ceker/Kaki Ayam",
    image: AyamCeker,
    desc: "Bagian kaki ayam segar",
    order: "Pesan sekarang!",
  },
  {
    name: "Cokor/Kaki Sapi",
    image: SapiCokor,
    desc: "Bagian daging sapi di bagian kaki ",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Gandik Sapi (Silver Side)",
    image: SapiGandik,
    desc: "Bagian paha belakang sapi terluar dan paling dasar",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Has Dalam Sapi (Tenderloin)",
    image: SapiHasDalam,
    desc: "Bagian daging sapi dari bagian tengah badan",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Has Luar Sapi (Sirloin)",
    image: SapiHasLuar,
    desc: " Bagian daging sapi yang berasal dari bagian bawah daging iga, terus sampai ke bagian sisi luar has dalam",
    order: "Pesan sekarang!",
  },
  {
    name: "Iga/Rib Sapi (Rib Meat)",
    image: SapiIga,
    desc: "Bagian daging sapi yang berasal dari daging di sekitar tulang iga atau tulang rusuk",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Kelapa Sapi (Knuckle)",
    image: SapiKelapa,
    desc: "Bagian daging sapi yang berasal dari paha belakang bagian atas yang berada di antara penutup dan gandik",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Sandung Lamur Sapi (Brisket)",
    image: SapiSandungLamur,
    desc: "Bagian daging sapi yang berasal dari bagian dada bawah sekitar ketiak",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Lamusir Depan Sapi (Cube Roll)",
    image: SapiLamusirDepan,
    desc: "Bagian daging sapi yang berasal dari daging di sekitar tulang iga atau tulang rusuk",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Paha Depan/Sampil Sapi (Chuck)",
    image: SapiPahaDepan,
    desc: "Bagian meliputi area punuk sapi, lalu turun hingga ke bahu dan paha bagian atas",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Punuk Sapi (Blade)",
    image: SapiPunuk,
    desc: "Bagian daging sapi bagian punuk. Ia menyambung dari daging atas ke paha depan",
    order: "Pesan sekarang!",
  },
  {
    name: "Ekor/Buntut Sapi (Oxtail)",
    image: SapiEkor,
    desc: "Bagian ekor dari tubuh sapi",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Sancan Sapi (Flank)",
    image: SapiSancan,
    desc: "Bagian daging sapi yang berasal dari otot perut",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Sengkel Sapi (Shank)",
    image: SapiSengkel,
    desc: "Bagian potongan daging di area betis hingga paha bawah sapi, depan maupun belakang",
    order: "Pesan sekarang!",
  },
  {
    name: "Daging Tanjung/Punggung Sapi (Rump)",
    image: SapiTanjung,
    desc: "Bagian daging sapi yang berasal dari punggung belakang",
    order: "Pesan sekarang!",
  },
];
